<!--suppress JSUnresolvedVariable -->
<template>
  <div>
    <div class="mt-4 ml-1">
      <el-row>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/admin/dashboard' }"
            >管理中心</el-breadcrumb-item
          >
          <el-breadcrumb-item>系统管理</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/admin/user/profile' }"
            >用户列表</el-breadcrumb-item
          >
          <el-breadcrumb-item
            ><span class="text-primary">编辑用户信息</span></el-breadcrumb-item
          >
        </el-breadcrumb>
      </el-row>
      <el-card class="my-4 mx-1">
        <div slot="header">
          <span class="font-weight-bold text-primary">编辑用户信息</span>
        </div>
        <el-form
          label-width="120px"
          class="font-weight-bold w-50"
          :model="userInfo"
        >
          <el-form-item label="用户名">
            <label>{{ userInfo.username }}</label>
          </el-form-item>
          <el-form-item label="昵称">
            <el-input v-model="userInfo.nickname"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="userInfo.phoneNumber"></el-input>
          </el-form-item>
          <el-form-item label="状态" v-if="userId !== 1">
            <el-radio-group v-model="userInfo.status">
              <el-radio :label="true" border>激活</el-radio>
              <el-radio :label="false" border>禁用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="密码"
            v-if="adminPermissions.includes('/adminUser/admin/resetPassword')"
          >
            <el-popconfirm
              placement="top"
              icon="el-icon-info"
              iconColor="red"
              @onConfirm="resetPassword(userInfo.userId)"
              title="确定要重置这个账号的密码么？"
            >
              <el-button slot="reference" type="warning">重置密码</el-button>
            </el-popconfirm>
          </el-form-item>
          <el-form-item label="角色配置">
            <el-checkbox-group v-model="selectedRolesIds">
              <el-checkbox
                v-for="(role, i) in roles"
                :key="i"
                :label="role.roleId"
                >{{ role.nameZh }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitUserInfoForm(userInfo)"
              >立即修改</el-button
            >
            <el-button @click="findUserById()">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditAdminUserInfo",

  data() {
    return {
      adminPermissions: this.$store.state.adminPermissions,
      userId: this.$route.params.userId,
      userInfo: {},
      selectedRolesIds: [],
      roles: []
    };
  },
  mounted() {
    this.findUserById();
    this.getRoles();
  },
  methods: {
    findUserById() {
      this.axios
        .get("/adminUser/findUserById", {
          params: {
            userId: this.userId
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.userInfo = resp.data.data;
            this.selectedRolesIds = resp.data.data.roles;
          }
        });
    },
    getRoles() {
      this.axios.get("/adminRole/admin/getRoleList", {}).then(resp => {
        if (resp && resp.data.code === 10000 && resp.data.success) {
          this.roles = resp.data.data;
        }
      });
    },
    submitUserInfoForm(userInfo) {
      this.axios
        .post("/adminUser/admin/updateUser", {
          userId: userInfo.userId,
          username: userInfo.username,
          nickname: userInfo.nickname,
          phoneNumber: userInfo.phoneNumber,
          status: userInfo.status,
          roles: this.selectedRolesIds
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.$notify({
              title: "成功",
              message: "用户信息修改成功",
              type: "success"
            });
            // 修改角色后返回用户列表界面
            this.$router.push({ name: "UserInfo" }).catch();
          } else {
            this.$notify.error({
              title: "错误",
              message: "用户信息修改失败！"
            });
          }
        });
    },

    resetPassword(userId) {
      this.axios
        .post("/adminUser/admin/resetPassword", {
          userId: userId
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.$notify({
              title: "成功",
              message: "密码已重置为 123",
              type: "success"
            });
          }
        });
    }
  }
};
</script>

<style scoped></style>
